import React from 'react';
import { withFormsy } from 'formsy-react'

import FieldError from './../FieldError'
import ReactHtmlParser from 'html-react-parser'
import withBaseFormsy from './withBaseFormsy'

class Input extends withBaseFormsy(React.Component) {
  constructor(props) {
    super(props)
    this.changeValue = this.changeValue.bind(this)
  }

  changeValue(event) {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.
    this.setValue(event)
    // this.updateValidates(this.props.name)
  }

  render() {
    // An error message is returned only if the component is invalid and has been interacted with
    const errorMessage = this.state._userTouched ? this.props.getErrorMessage() : null;

    const item = this.props.item || {}

    return (
      <div className={this.props.className}>
        <label htmlFor={`input_${item.id}`}>
          {item.name}{this.props.required && !this.props.isHideRequiredLabel ? <span className="label-require">(必須)</span> : ""} <br/>
          {typeof item.note === 'string' && ReactHtmlParser(item.note)}
        </label>
        <input
          autoComplete="off"
          onChange={this.changeValue}
          id={item.id}
          className={`form-control ${errorMessage ? "has-error" : ""}`}
          type={this.props.type}
          name={this.props.name}
          defaultValue={this.props.defaultValue}
        />
        { errorMessage && <FieldError message={errorMessage} /> }
      </div>
    );
  }
}

export default withFormsy(Input);
